export default {
  list: { lazy: () => import('./PaymentFactors'), component: 'PaymentFactorList' },
  create: { lazy: () => import('./PaymentFactors'), component: 'PaymentFactorCreate' },
  edit: { lazy: () => import('./PaymentFactors'), component: 'PaymentFactorEdit' },
}
